<div [class.loading-overlay]="loading">
  <div
    class="grid-x savings-wrapper"
    [class.no-change]="anfrage.measureResult && demandClass === recommendClass"
  >
    @if (anfrage.measureResult) {
      <div class="cell">
        <h4 [innerHTML]="textkeyPrefix + '.headline.effizienzklasse' | translate"></h4>
      </div>
      @for (effizienzklasse of effizienzklassen; let i = $index; track effizienzklasse) {
        <div
          class="cell saving-bar-wrapper"
          [style]="'--i:' + (i + 1)"
          [class.show-for-xmedium]="!(demandClass === effizienzklasse) && !(recommendClass === effizienzklasse)"
        >
          <span
            class="saving-bar arrow gray class-{{ effizienzklasse }}"
            [class.demand]="demandClass === effizienzklasse"
            [class.recommend]="recommendClass === effizienzklasse"
            role="img"
            aria-hidden="true"
          >{{ (effizienzklasse === 'a_plus'? 'a+' : effizienzklasse) | uppercase }}</span>
          @if(demandClass === effizienzklasse && demandClass !== recommendClass) {
            <span [innerHTML]="textkeyPrefix + '.effizienzklasse.heute' | translate: {'measureResult': anfrage.measureResult}" aria-live="polite"></span>
          }
          @if(demandClass === effizienzklasse && recommendClass === effizienzklasse && anfrage.measureResult.demand.kwh === anfrage.measureResult.recommend.kwh) {
            <span [innerHTML]="textkeyPrefix + '.effizienzklasse.gleich' | translate: {'measureResult': anfrage.measureResult}" aria-live="polite"></span>
          }
          @if(demandClass === effizienzklasse && recommendClass === effizienzklasse && anfrage.measureResult.demand.kwh !== anfrage.measureResult.recommend.kwh) {
            <span [innerHTML]="textkeyPrefix + '.effizienzklasse.gleicheklasse' | translate: {'measureResult': anfrage.measureResult}" aria-live="polite"></span>
          }
          @if(recommendClass === effizienzklasse && demandClass !== recommendClass) {
            <span [innerHTML]="textkeyPrefix + '.effizienzklasse.zukuenftig' | translate: {'measureResult': anfrage.measureResult}" aria-live="polite"></span>
          }
        </div>
      }
    }
  </div>
  <div class="grid-x savings-wrapper">
    <div class="cell">
      <h4 [innerHTML]="textkeyPrefix + '.headline.co2' | translate"></h4>
    </div>

    <div class="cell saving-bar-wrapper">
      <span
        class="saving-bar primary"
        [class.max]="consumption.co2.current < consumption.co2.sanitized"
        [style]="'--percent:' + (consumption.co2.sanitized / consumption.co2.current)"
        role="img"
        aria-hidden="true"
      >&nbsp;</span>
      <span [innerHTML]="textkeyPrefix + '.co2.zukuenftig' | translate: {'co2': (consumption.co2.sanitized | number: '1.0-1')}" aria-live="polite"></span>
    </div>
    <div class="cell saving-bar-wrapper">
      <span
        class="saving-bar medium"
        [class.max]="consumption.co2.current > consumption.co2.sanitized"
        [style]="'--percent:' + (consumption.co2.current / consumption.co2.sanitized)"
        role="img"
        aria-hidden="true"
      >&nbsp;</span>
      <span [innerHTML]="textkeyPrefix + '.co2.heute' | translate: {'co2': (consumption.co2.current | number: '1.0-1')}" aria-live="polite"></span>
    </div>
  </div>
</div>
